import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { startEventPage } from "../../store/publicEvents";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Grid, Typography, Container } from "@mui/material";
import { PublicLayout } from "../../layouts";

import { EventTicketsView, EventDataView } from "./views";

import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { EventInterface } from "../../interfaces";

export const EventPage = () => {
  const { id = 0 } = useParams();
  const [loading, setLoading] = useState(true);

  const { status, eventData, errorMessage } = useSelector(
    (state: RootState) => state.publicEvents
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(startEventPage(+id, setLoading));
  }, [dispatch, id]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (eventData === null || status === "loadingError") {
    return (
      <PublicLayout>
        <Container>
          <Typography variant="h3" sx={{ my: 4, textAlign: "center" }}>
            {errorMessage ? errorMessage : "No se encontraron datos"}
          </Typography>
        </Container>
      </PublicLayout>
    );
  }

  const event = eventData as EventInterface;

  return (
    <PublicLayout>
      <Container sx={{ marginTop: 15 }}>
        <Grid
          container
          justifyContent={"space-between"}
          sx={{
            justifyContent: { xs: "center", md: "space-between" },
          }}
        >
          <Grid
            container
            item
            xs={12}
            sm={9}
            md={5}
            lg={6}
            justifyContent={"center"}
            alignContent={"flex-start"}
          >
            <Grid item xs={12}>
              <EventDataView
                description={event.description}
                address={event.address}
                startDate={event.startDate}
                venueDetails={event.venueDetails}
                endDate={event.endDate}
                title={event.name}
                longitude={event.longitude.toString()}
                latitude={event.latitude.toString()}
                organization={event.organization}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={10} md={7} lg={5}>
            <Box
              sx={{
                backgroundColor: "transparent",
                borderRadius: 2,
                boxShadow: "0px",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  backgroundImage: `url("${event.banner}")`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "600px",
                  width: "100%",
                  mb: 5,
                }}
              />

              <EventTicketsView tickets={event.ticketVariants} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </PublicLayout>
  );
};
